export default "__VITE_ASSET__BEAWLdWX__"